import Address from '@modules/husleie-framework/src/types/Address.entity';
import { User } from '@modules/husleie-framework/src/types/User.entity';

const enum LandlordTypeEnum {
  PROFESSIONAL = 'PROFESSIONAL',
  PRIVATE = 'PRIVATE',
}
type LandlordType = LandlordTypeEnum.PRIVATE | LandlordTypeEnum.PROFESSIONAL;

interface Landlord {
  type: null | LandlordType;
  id: null | number;
  address?: Address;
  user?: User;
  ownerName?: string;
  numberOfRentalObjects?: number;
  numberOfTenancies?: number;
  meta?: any;
}

export { LandlordTypeEnum, LandlordType, Landlord };
